import { render } from "./Multiple.vue?vue&type=template&id=185a3871&scoped=true"
import script from "./Multiple.vue?vue&type=script&lang=js"
export * from "./Multiple.vue?vue&type=script&lang=js"

import "./Multiple.vue?vue&type=style&index=0&id=185a3871&lang=css&scoped=true"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185a3871"]])

export default __exports__